import { appContact } from 'straightline-utils/validation/schemas';

export default (app) => {
  return appContact;
};
